import "@/components/certification-backdrop.css";

export const CertificationBackdrop = () => <div className="gfc-certification-backdrop" aria-hidden="true" data-testid="home-certifications-backdrop">
  <img src="/certificazioni/quality-review.webp" alt="" width="1800" height="1200" loading="lazy" decoding="async" data-testid="home-certifications-background-image" />
</div>;